import { AnalyticsPeriod, IPriceAnalytics } from "@/types/IAnalytics"
import { ITableColumn } from "@/types/ui"

import { getMoney } from "@/utils/formatNumber"
export const periods = [
  {
    label: "Год",
    value: AnalyticsPeriod.Yearly
  },
  {
    label: "Квартал",
    value: AnalyticsPeriod.Quarterly
  },
  {
    label: "Месяц",
    value: AnalyticsPeriod.Monthly
  },
  {
    label: "Неделя",
    value: AnalyticsPeriod.Weekly
  }
]

export const analyticsPriceColumns = (sorter: boolean): ITableColumn<IPriceAnalytics>[] => [
  {
    title: "Период",
    key: "period",
    dataIndex: ["period"],
    sorter: false,
    isVisible: true,
    order: 1
  },
  {
    title: "Тип топлива",
    key: "refusalCount",
    dataIndex: ["refusalCount"],
    render: (_, { fuels }) => 
    <>{fuels && fuels.map((x) => (
        <div key={crypto.randomUUID()}>
          {x.fuelTypeName}
        </div>
      ))}
    </>,
    sorter: sorter,
    isVisible: true,
    order: 2
  },
  {
    title: "Цена",
    key: "refusalAmount",
    dataIndex: ["refusalAmount"],
    render: (_, { fuels }) => 
    <>{fuels && fuels.map((x) => (
        <div key={crypto.randomUUID()}>
          {getMoney(x.price, 0)}
        </div>
      ))}
    </>,
    sorter: sorter,
    isVisible: true,
    order: 3
  }
]